import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dialog"
export default class extends Controller {
    static targets = ["panel", "backdrop"]
    static values = {
        open: { type: Boolean, default: false }
    }

    connect() {
        this.element.addEventListener("dialog:open", () => this.open())
    }

    disconnect() {
        this.element.removeEventListener("dialog:open", () => this.open())
    }

    handleBackdropClick(event) {
        if (event.target === this.backdropTarget) {
            this.close()
        }
    }

    open() {
        this.openValue = true
        this.element.classList.remove("hidden")

        // Backdrop transition
        if (this.hasBackdropTarget) {
            this.backdropTarget.classList.remove("opacity-0")
            this.backdropTarget.classList.add("opacity-100")
        }

        // Save current translation before opening
        this.closingClass = this.panelTarget.classList.contains("translate-x-full") ? "translate-x-full" : "-translate-x-full"

        // Panel transition
        requestAnimationFrame(() => {
            this.panelTarget.classList.remove("translate-x-full", "-translate-x-full", "opacity-0")
            this.panelTarget.classList.add("translate-x-0", "opacity-100")
        })
    }

    close() {
        this.openValue = false

        // Backdrop transition
        if (this.hasBackdropTarget) {
            this.backdropTarget.classList.remove("opacity-100")
            this.backdropTarget.classList.add("opacity-0")
        }

        // Use the saved closing class
        this.panelTarget.classList.add(this.closingClass)
        this.panelTarget.classList.remove("translate-x-0")

        setTimeout(() => {
            if (!this.openValue) {
                this.element.classList.add("hidden")
            }
        }, 300)
    }
}
